import React from "react";
import { X } from "lucide-react";
import { useOnboarding } from "../../contexts/OnboardingContext";
import { useWsNavigate } from "../../hooks/useWsNavigate";

const ProgressRing = ({ percent }) => {
  const r = 8;
  const c = 2 * Math.PI * r;
  const offset = c - (percent / 100) * c;
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" className="flex-shrink-0">
      <circle cx="11" cy="11" r={r} fill="none" strokeWidth="2.5" className="stroke-border" />
      <circle
        cx="11"
        cy="11"
        r={r}
        fill="none"
        strokeWidth="2.5"
        strokeLinecap="round"
        className="stroke-primary"
        strokeDasharray={c}
        strokeDashoffset={offset}
        transform="rotate(-90 11 11)"
      />
    </svg>
  );
};

const OnboardingFooterBar = () => {
  const { showOnboarding, percent, completed, total, steps, dismiss } = useOnboarding();
  const navigate = useWsNavigate();

  if (!showOnboarding) return null;

  const nextStep = steps.find((s) => !s.done);

  const goToChecklist = () => {
    navigate("/onboarding");
  };

  const handleDismiss = (e) => {
    e.stopPropagation();
    if (window.confirm("Hide setup guide? You can reopen it any time from the sidebar.")) {
      dismiss();
    }
  };

  return (
    <div className="sticky bottom-0 z-20 shrink-0 border-t border-border bg-card shadow-[0_-1px_3px_rgba(0,0,0,0.04)]">
      <div className="flex items-center gap-4 px-4 py-2.5">
        <button
          data-testid="onboarding-footer-body"
          onClick={goToChecklist}
          className="flex items-center gap-4 flex-1 text-left"
        >
          <span className="text-sm font-medium text-foreground">Getting started</span>
          {nextStep && (
            <span className="text-sm text-muted-foreground truncate">
              Next: {nextStep.title}
            </span>
          )}
          <span className="ml-auto flex items-center gap-2 text-xs text-muted-foreground">
            {percent}% · {completed}/{total} steps
            <ProgressRing percent={percent} />
          </span>
        </button>
        <button
          onClick={handleDismiss}
          aria-label="Hide setup guide"
          className="p-1.5 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors flex-shrink-0"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default OnboardingFooterBar;
